import React from 'react';

const Footer = ({ onHomeClick, onAboutClick, onContactClick, onCourseSelect }) => {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%)',
      color: 'white',
      padding: '2.5rem 2rem 0rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>
        {`
          .footer-link {
            transition: all 0.3s ease;
            display: inline-block;
            position: relative;
          }
          .footer-link::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: -2px;
            left: 0;
            background-color: #ff6b35;
            transition: width 0.3s ease;
          }
          .footer-link:hover {
            color: #ff6b35 !important;
          }
          .footer-link:hover::after {
            width: 100%;
          }
          .footer-contact {
            transition: all 0.3s ease;
            display: inline-block;
            position: relative;
          }
          .footer-contact::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: -2px;
            left: 0;
            background-color: #ff6b35;
            transition: width 0.3s ease;
          }
          .footer-contact:hover {
            color: #ff6b35 !important;
          }
          .footer-contact:hover::after {
            width: 100%;
          }
          .social-icon {
            transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
            transform-style: preserve-3d;
          }
          .social-icon:hover {
            transform: translateY(-8px) rotateZ(10deg) scale(1.2);
            filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
          }

          @media (max-width: 768px) {
            footer {
              padding: 1rem 1rem 0rem !important;
            }
            .footer-content {
              flex-direction: column !important;
              gap: 0.3rem !important;
              text-align: center !important;
              padding: 0 0.5rem !important;
              margin-bottom: 0.5rem !important;
            }
            .footer-section {
              flex: none !important;
              margin-bottom: 0.5rem !important;
            }
            .footer-section h3 {
              font-size: 1.1rem !important;
              margin-bottom: 0.5rem !important;
              padding-bottom: 0.3rem !important;
            }
            .footer-section h3 span {
              width: 40px !important;
            }
            .footer-link {
              font-size: 0.85rem !important;
              padding: 0.15rem 0 !important;
              display: block !important;
            }
            .footer-contact {
              font-size: 0.85rem !important;
              padding: 0 !important;
              display: inline !important;
            }
            .footer-section > div {
              gap: 0.3rem !important;
            }
            .footer-section:nth-child(2) > div {
              gap: 0.4rem !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .footer-section:nth-child(2) p {
              font-size: 0.85rem !important;
              margin: 0 !important;
              line-height: 1.3 !important;
              white-space: nowrap !important;
              overflow-x: auto !important;
              text-align: center !important;
              display: block !important;
            }
            .footer-section:first-child > div {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .footer-social {
              justify-content: space-between !important;
              flex-wrap: nowrap !important;
              gap: 0 !important;
              flex-direction: row !important;
              display: flex !important;
              align-items: center !important;
              width: 100% !important;
              margin: 0 auto !important;
              padding: 0 1rem !important;
            }
            .social-icon {
              width: 35px !important;
              height: 35px !important;
              flex-shrink: 0 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
            }
            .social-icon svg {
              width: 35px !important;
              height: 35px !important;
            }
            .footer-section {
              text-align: center !important;
              width: 100% !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              margin-bottom: 1.5rem !important;
            }
            .footer-section h3 {
              text-align: center !important;
              margin-bottom: 1rem !important;
            }
            .footer-section > div {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              width: 100% !important;
            }
            .footer-section:last-child .footer-social {
              flex-direction: row !important;
              justify-content: center !important;
              flex-wrap: nowrap !important;
              display: flex !important;
            }
            .footer-section:nth-child(3) > div {
              flex-direction: column !important;
              align-items: center !important;
            }
            .footer-section:nth-child(3) .footer-link {
              display: block !important;
              text-align: center !important;
              width: 100% !important;
            }
            footer > div:last-child p {
              font-size: 0.9rem !important;
            }
          }
        `}
      </style>
      
      <div className="footer-content" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '4rem',
        marginBottom: '2rem',
        maxWidth: '1400px',
        margin: '0 auto 2rem auto'
      }}>
        
        <div className="footer-section" style={{ flex: '1.2' }}>
          <h3 style={{ 
            marginBottom: '2rem', 
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Contact Info
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%)',
              borderRadius: '2px'
            }}></span>
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
            <p style={{ margin: 0, color: '#bdc3c7', whiteSpace: 'nowrap' }}>
              <a href="mailto:oraniumtech@gmail.com" className="footer-contact" style={{ color: '#bdc3c7', textDecoration: 'none' }}>oraniumtech@gmail.com</a>
            </p>
            <p style={{ margin: 0, color: '#bdc3c7', whiteSpace: 'nowrap' }}>
              Chrompet / Velachery: <a href="tel:+917871719161" className="footer-contact" style={{ color: '#bdc3c7', textDecoration: 'none' }}>7871719161</a>
            </p>
            <p style={{ margin: 0, color: '#bdc3c7', whiteSpace: 'nowrap' }}>Chennai, India (Head Office)</p>
          </div>
        </div>
        
        <div className="footer-section" style={{ flex: '1.2' }}>
          <h3 style={{ 
            marginBottom: '2rem', 
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Popular Courses
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%)',
              borderRadius: '2px'
            }}></span>
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('MERN Full-Stack Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Full Stack Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Azure Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Azure Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('AWS Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>AWS Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Data Science with Gen-AI Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Data Science with Gen AI Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('DevOps Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>DevOps Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Power BI Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Power BI Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Power Apps Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Power Platform Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Selenium Automation Training (Java/Python/C#)'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Selenium Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Playwright Automation Training (TypeScript)'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Playwright Training</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCourseSelect?.('Generative AI Training'); }} className="footer-link" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem', cursor: 'pointer' }}>Generative AI Training</a>
          </div>
        </div>
        
        <div className="footer-section" style={{ flex: '1' }}>
          <h3 style={{ 
            marginBottom: '2rem', 
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Follow Us
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%)',
              borderRadius: '2px'
            }}></span>
          </h3>
          <div className="footer-social" style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-start' }}>
            <a href="https://www.facebook.com/OraniumTech/" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ color: '#cbd5e1', transition: 'all 0.3s' }} aria-label="Visit Oranium Tech on Facebook">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/oraniumtechofficial/?hl=en" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ color: '#cbd5e1', transition: 'all 0.3s' }} aria-label="Visit Oranium Tech on Instagram">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
              </svg>
            </a>
            <a href="https://in.linkedin.com/company/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ color: '#cbd5e1', transition: 'all 0.3s' }} aria-label="Visit Oranium Tech on LinkedIn">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://x.com/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ color: '#cbd5e1', transition: 'all 0.3s' }} aria-label="Visit Oranium Tech on X (Twitter)">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

      </div>
      
      <div style={{
        borderTop: '2px solid rgba(96, 165, 250, 0.2)',
        paddingTop: '1rem',
        textAlign: 'center',
        background: 'rgba(0,0,0,0.1)',
        margin: '0 -2rem 0 -2rem',
        padding: '1rem 2rem'
      }}>
        <p style={{
          fontSize: '0.95rem',
          fontWeight: '500',
          color: '#bdc3c7',
          margin: 0
        }}>© {new Date().getFullYear()} Oranium Tech. Empowering IT Careers. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;